import './style.scss';

import cn from 'classnames';
import React, { HTMLAttributes, useMemo } from 'react';

interface IStatisTableProps extends HTMLAttributes<HTMLTableElement> {
  children?: React.ReactNode;
}

const StaticTable: React.FC<IStatisTableProps> = ({ children, ...rest }) => {
  const className = useMemo(() => cn('mm-static-table', rest.className ?? ''), [rest.className]);

  return (
    <table {...rest} className={className}>
      {children}
    </table>
  );
};

export { StaticTable };
